module.exports = __webpack_public_path__ + "static/media/instagram.42a1be4c.svg";